import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asset-information-popover',
  templateUrl: './asset-information-popover.component.html',
  styleUrls: ['./asset-information-popover.component.scss'],
})
export class AssetInformationPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
